var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconTip = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_tip")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bswap",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Redeem-BTC",
    transform: "translate(-237.000000, -582.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(140.000000, 134.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_tip",
    transform: "translate(97.500000, 448.137537)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#979797",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#F2A337",
    strokeWidth: 1.56521739,
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,15.0687618 C11.2507389,15.0687618 10.6432739,15.6760469 10.6432739,16.4254879 C10.6432739,17.174749 11.2507389,17.782214 12,17.782214 C12.7492611,17.782214 13.3567261,17.174749 13.3567261,16.4254879 C13.3567261,15.6760451 12.7492611,15.0687618 12,15.0687618 Z M11.9609835,14.0080905 C12.6063812,14.0080905 13.1294925,13.4847993 13.1294925,12.8395815 L13.1294925,7.38629498 C13.1294925,6.74089727 12.606383,6.217786 11.9609835,6.217786 C11.3155858,6.217786 10.7924745,6.7410772 10.7924745,7.38629498 L10.7924745,12.8395815 C10.7924745,13.4849792 11.315584,14.0080905 11.9609835,14.0080905 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#F2A337",
    transform: "translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "
  })))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTip, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_tip.4fb4d418.svg";
export { ForwardRef as ReactComponent };